import React, { Component } from 'react';
import { connect } from 'react-redux';
import './prBidRequest.scss';
import { Tabs, Modal, Button } from 'antd';
import { fromValidate, history } from '../../../helpers'
import Header from "../../../layout/DefaultLayout/Header";
import Avatar from "../../../images/img_avatar.png";
const { confirm } = Modal;

class MyBooking extends Component {

   constructor(props) {
      super(props);
      this.state = {
         formError: {},
         formSubmit: false,
         user: {},
         userNumber: '****7890',
         isSuccess: true,
      }
   }

   showConfirm = () => {
    confirm({
        title: 'You will be charged 50 credit points!',
        content: '45 Credits will be refunded, if bidding is not approved by the customer. Do you want to continue?',
        okText: 'YES',
        cancelText: 'NO',
    });
  }

//    showModalBid = () => {
//     this.setState({
//         visibleBid: true,
//     });
//     };

//     handleOkBid = e => {
//         console.log(e);
//         this.setState({
//             visibleBid: false,
//         });
//     };

//     handleCancelBid = e => {
//         console.log(e);
//         this.setState({
//             visibleBid: false,
//         });
//     };


   render() {
      const { user, formError, formSubmit, userNumber, isSuccess } = this.state;
      const { TabPane } = Tabs;
      return (
         <div>
            <Header></Header>
            <div className='pr-container'>
            <div className="main-heading-txt">My Booking</div>

            <Tabs defaultActiveKey="1">
                <TabPane tab="ONGOING" key="1">
                <div className="request-box">
                    <div className="row">
                        
                        <div className="col-5">
                            <div className='card-heading-sub-text'>Wire 200m : <span>INR 1200</span></div>
                            <div className='card-heading-sub-text'>Socket : <span>INR 400</span></div>
                            <div className='card-heading-sub-text'>Total : <span>INR 1600</span></div>
                        </div>
                        <div className="col-4">
                          <div className='card-heading-sub-text'>Booked On</div>
                          <div className='card-heading-sub-text'>2020-10-13</div>
                          <div className='card-heading-sub-text'>12:30 pm</div>
                        </div>
                        <div className="col-3">
                        <div className='card-bid-now-btn' onClick={() => this.showConfirm()}>Edit Bit</div>
                        </div>
                    </div>
                </div>
                
                </TabPane>
                <TabPane tab="HISTORY" key="2">
                    <div>jfjfj</div>
                </TabPane>
            </Tabs>
             
            </div>
         </div>
      )
   }
}

function mapStateToProps(state) {
   const { user } = state.authentication;
   return {
      user,
   }
}
export default connect(mapStateToProps)(MyBooking);